import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Text } from '../../constants/TextConstants'
import { PERMISSION_CODES } from '../../constants/permissions'
import { useSave } from '../../Context/saveContext'
import { ModalSupport } from '../HeaderMenu/Modals/Support'
import { BqIcon, BqOption, BqOptionList } from '@beeq/react'
import { StyledBqButton, StyledBqDropdown, StyledBqSideMenu, StyledBqSideMenuItem, StyledDiv } from './styles'

import { NAV_ITEMS } from './constants'

export const SideBar = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { profileEmail, userPermissions } = useSave()
  const [openSupport, setOpenSupport] = useState(false)

  const [selectedItem, setSelectedItem] = useState(null)
  const [isCollapsed, setIsCollapsed] = useState(false)

  const editRolesPermission = userPermissions.includes(PERMISSION_CODES.viewCreateEditRoles.code)
  const assignRolesPermission = userPermissions.includes(PERMISSION_CODES.assignRoles.code)
  const editListPermission = userPermissions.includes(PERMISSION_CODES.viewEditLists.code)
  const changeSupportPermission = userPermissions.includes(PERMISSION_CODES.changeSupport.code)
  const viewMyTeamPagePermission = userPermissions.includes(PERMISSION_CODES.viewMyTeamPage.code)

  useEffect(() => {
    const pathnameWithoutSlash = location.pathname.split('/')[1] || 'view'
    const pathIndex = NAV_ITEMS.findIndex(navItem => navItem.key === pathnameWithoutSlash)

    setSelectedItem(pathIndex)
  }, [])

  const updatedNavItems = useMemo(() => {
    return NAV_ITEMS
      .map((item) => {
        if (item.label === Text.Profiles) {
          item.showCondition = viewMyTeamPagePermission
        }
        if (item.label === Text.RolesPermissions) {
          item.showCondition = editRolesPermission || assignRolesPermission
        }
        if (item.label === Text.ListManagement) {
          item.showCondition = editListPermission
        }
        return item
      })
      .filter((item) => item.showCondition !== false)
  }, [userPermissions])

  const routeChange = (path, index) => {
    navigate(path)
    setSelectedItem(index)
  }

  return (
    <StyledBqSideMenu collapse={isCollapsed} data-testid='side-bar'>
      <StyledDiv
        slot='logo'
        style={{ textAlign: 'center' }}
        data-testid='endava-logo'
        onClick={() => routeChange('/', 0)}>
        {!isCollapsed ? (
          <img
            src={process.env.PUBLIC_URL + '/logo.png'}
            width='auto'
            height='30'
            alt='Logo Endava'
            data-testid='full-logo'
          />
        ) : (
          <img
            src={process.env.PUBLIC_URL + '/endavaLogo.png'}
            width='auto'
            height='30'
            alt='Logo Endava'
            data-testid='logo'
          />
        )}
      </StyledDiv>

      {updatedNavItems.map((item, index) => (
        <span key={index}>
          {item.children ? (
            <StyledBqDropdown panelHeight='200px' data-testid={`sub-menu-${index}`}>
              <StyledBqSideMenuItem slot='trigger' data-testid={`item-${item.label.replace(/\s/g, '')}`}>
                <BqIcon name={item.icon} slot='prefix'></BqIcon>
                {!isCollapsed ? item.label : ''}
              </StyledBqSideMenuItem>

              <BqOptionList ariaLabel='options' role='listbox'>
                {item.children.map((childItem, childIndex) => (
                  <BqOption
                    key={childIndex}
                    onClick={() => routeChange(childItem.action)}
                    value={childItem.label}
                    data-testid={`subitem-${childItem.label.replace(/\s/g, '')}`}>
                    <span>{childItem.label}</span>
                  </BqOption>
                ))}
              </BqOptionList>
            </StyledBqDropdown>
          ) : (
            <StyledBqSideMenuItem
              active={selectedItem === index}
              key={index}
              slot='trigger'
              data-testid={`item-${item.label.replace(/\s/g, '')}`}
              onBqClick={() => routeChange(item.action, index)}>
              <BqIcon name={item.icon} slot='prefix'></BqIcon>
              {item.label}
            </StyledBqSideMenuItem>
          )}
        </span>
      ))}

      <StyledBqSideMenuItem data-testid='item-Support' onBqClick={() => setOpenSupport(true)}>
        <BqIcon name='lifebuoy' slot='prefix'></BqIcon>
        {Text.Support}
      </StyledBqSideMenuItem>

      <div slot='footer' style={{ paddingLeft: isCollapsed ? '8px' : '12px' }}>
        <StyledBqButton
          appearance='text'
          slot='footer'
          data-testid='collapse-btn'
          onBqClick={() => setIsCollapsed(!isCollapsed)}>
          <BqIcon name={!isCollapsed ? 'arrow-line-left' : 'arrow-line-right'} slot='prefix'></BqIcon>
          {!isCollapsed ? Text.Collapse : ''}
        </StyledBqButton>
      </div>

      <ModalSupport
        loginMail={profileEmail}
        open={openSupport}
        setModal={setOpenSupport}
        isAdminTab={changeSupportPermission}
      />
    </StyledBqSideMenu>
  )
}
